<template>
  <div>
    <table border="0" cellspacing="0" cellpadding="0" class="fff channelList" width="100%">
      <tr class="headTr">
        <th class="headTh one" style="width: 8%">
          <div class="vertical">Airline</div>
        </th>
        <th class="headTh" style="width: 20%">
          <!-- POL &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  T/T Route &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  POD -->
          <div class="vertical">
            <div class="colorClass">
              <b>Route</b>
              <p>
                <img src="../../../../../static/img/1x.png" style="margin: -2px 38% -2px; width: 50px" />
              </p>
              <b>T/T</b>
            </div>
          </div>
        </th>
        <th class="headTh" style="width: 15%">
          <div class="vertical">Frequency</div>
        </th>
        <th :class="getKg == '45' ? 'headThColor' : 'headTh'" style="width: 6%">
          <div class="vertical">
            45KG<span class="arrow asc"></span><span class="arrow dsc"></span>
          </div>
        </th>
        <th :class="getKg == '100' ? 'headThColor' : 'headTh'" style="width: 7%">
          <div class="vertical">
            100KG<span class="arrow asc"></span><span class="arrow dsc"></span>
          </div>
        </th>
        <th :class="getKg == '300' ? 'headThColor' : 'headTh'" style="width: 7%">
          <div class="vertical">
            300KG<span class="arrow asc"></span><span class="arrow dsc"></span>
          </div>
        </th>
        <th :class="getKg == '500' ? 'headThColor' : 'headTh'" style="width: 7%">
          <div class="vertical">
            500KG<span class="arrow asc"></span><span class="arrow dsc"></span>
          </div>
        </th>
        <th :class="getKg == '1000' ? 'headThColor' : 'headTh'" style="width: 8%">
          <div class="vertical">
            1000KG+<span class="arrow asc"></span><span class="arrow dsc"></span>
          </div>
        </th>
        <th class="headTh" style="width: 10%">
          <div class="vertical">Action</div>
        </th>
        <th class="headTh last" style="width: 12%">Booking</th>
      </tr>
    </table>
    <template v-for="(item, index) in newList.slice(0, tiaoshu)">
      <table border="0" cellspacing="0" cellpadding="0" class="channelList1" width="100%" :key="index" v-if="item.showleft">
        <tr class="headTr" style="height: 90px">
          <td class="headTh one" style="width: 8%">
            <div class="left-label" v-if="item.IsEnRecommend">
              <img src="../../../../../static/img/tuijian.png" width="32px" height="30px" />
            </div>
            <div class="verbar" :class="{ marTop: item.IsEnRecommend }">
              <span class="fa fa-AirWarehouse colBlue" style="font-size: 30px; margin-top: -21px" v-if="!item.AirCompanyLogo"></span>
              <span class="fa colBlue" style="font-size: 30px; margin-top: -21px" v-if="item.AirCompanyLogo"><img :src="$apiFileCloud +'/' + item.AirCompanyLogo" width="33px" height="33px" /></span>
              <b class="codeTwo">{{ item.AirCompanyCode2 }}-{{ item.AirCompanyCode3 }}</b>
            </div>
          </td>
          <td class="headTh" style="width: 20%">
            <div class="verbar">
              <!-- <div class="polClass">{{item.StartAirPortCode3}}</div> -->
              <div class="polpod">
                <!-- <p class="daysClass">{{ item.ValidTerm }} Days</p> -->
                <p class="daysClass">{{ item.FlightCourse }}</p>
                <p><img src="../../../../../static/img/1x.png" /></p>
                <p class="transClass">
                  {{ item.ValidTerm }} {{ item.ValidTerm != 1 ? "Days" : "Day" }}
                </p>
                <!-- <p class="transClass">{{item.AirArrivalType == 1 ? "Direct" : "Transit"}}</p> -->

                <!-- <div class="demo">
              {{ item.FlightCourse }}
                <div class="out"></div>
                <div class="in"></div>
            </div> -->
              </div>
              <!-- <div class="podClass">{{item.DestAirPortCode3}}</div> -->
            </div>
          </td>
          <td class="headTh" style="width: 15%">
            <div class="verbar">
              <!-- <div v-if="item.Flight == 'Daily' || item.Flight =='DAILY' || item.Flight == '1/2/3/4/5/6/7'">
													Daily
													</div> -->
              <table class="dateClass">
                <tr>
                  <td :class="item.Flight.indexOf('7') != -1 ? 'selectDate' : ''" style="border-top-left-radius: 10px">
                    SUN
                  </td>
                  <td :class="item.Flight.indexOf('1') != -1 ? 'selectDate' : ''">MON</td>
                  <td :class="item.Flight.indexOf('2') != -1 ? 'selectDate' : ''">TUE</td>
                  <td :class="item.Flight.indexOf('3') != -1 ? 'selectDate' : ''" style="border-top-right-radius: 10px">
                    WED
                  </td>
                </tr>
                <tr>
                  <td :class="item.Flight.indexOf('4') != -1 ? 'selectDate' : ''" style="border-bottom-left-radius: 10px">
                    THU
                  </td>
                  <td :class="item.Flight.indexOf('5') != -1 ? 'selectDate' : ''">FRI</td>
                  <td :class="item.Flight.indexOf('6') != -1 ? 'selectDate' : ''">SAT</td>
                  <td style="border-bottom-right-radius: 10px"></td>
                </tr>
              </table>
            </div>
          </td>
          <td :class="getKg == '45' ? 'headThColor' : 'headTh'" style="width: 6%">
            <template v-for="(item1, index) in item.ReferFeeList">
              <div class="verbar" :key="index" v-if="getKg == 45 && item1.ChargeWeight == 45">
                ${{ item.AirPrice.toFixed(2) }}
              </div>
              <div class="verbar" :key="index" v-else-if="item1.ChargeWeight == 45">
                ${{ Number(item1.Price).toFixed(2) }}
              </div>
            </template>
            <div v-if="!item.ReferFeeList.some((v) => v.ChargeWeight == 45)" class="verbar">
              -
            </div>
          </td>
          <td :class="getKg == '100' ? 'headThColor' : 'headTh'" style="width: 7%">
            <template v-for="(item1, index) in item.ReferFeeList">
              <div class="verbar" :key="index" v-if="getKg == 100 && item1.ChargeWeight == 100">
                ${{ item.AirPrice.toFixed(2) }}
              </div>
              <div class="verbar" :key="index" v-else-if="item1.ChargeWeight == 100">
                ${{ Number(item1.Price).toFixed(2) }}
              </div>
            </template>
            <div v-if="!item.ReferFeeList.some((v) => v.ChargeWeight == 100)" class="verbar">
              -
            </div>
          </td>
          <td :class="getKg == '300' ? 'headThColor' : 'headTh'" style="width: 7%">
            <template v-for="(item1, index) in item.ReferFeeList">
              <div class="verbar" :key="index" v-if="getKg == 300 && item1.ChargeWeight == 300">
                ${{ item.AirPrice.toFixed(2) }}
              </div>
              <div class="verbar" :key="index" v-else-if="item1.ChargeWeight == 300">
                ${{ Number(item1.Price).toFixed(2) }}
              </div>
            </template>
            <div v-if="!item.ReferFeeList.some((v) => v.ChargeWeight == 300)" class="verbar">
              -
            </div>
          </td>
          <td :class="getKg == '500' ? 'headThColor' : 'headTh'" style="width: 7%">
            <template v-for="(item1, index) in item.ReferFeeList">
              <div class="verbar" :key="index" v-if="getKg == 500 && item1.ChargeWeight == 500">
                ${{ item.AirPrice.toFixed(2) }}
              </div>
              <div class="verbar" :key="index" v-else-if="item1.ChargeWeight == 500">
                ${{ Number(item1.Price).toFixed(2) }}
              </div>
            </template>
            <div v-if="!item.ReferFeeList.some((v) => v.ChargeWeight == 500)" class="verbar">
              -
            </div>
          </td>
          <td :class="getKg == '1000' ? 'headThColor' : 'headTh'" style="width: 8%">
            <template v-for="(item1, index) in item.ReferFeeList">
              <div class="verbar" :key="index" v-if="getKg == 1000 && item1.ChargeWeight == 1000">
                ${{ item.AirPrice.toFixed(2) }}
              </div>
              <div class="verbar" :key="index" v-else-if="item1.ChargeWeight == 1000">
                ${{ Number(item1.Price).toFixed(2) }}
              </div>
            </template>
            <div v-if="!item.ReferFeeList.some((v) => v.ChargeWeight == 1000)" class="verbar">
              -
            </div>
          </td>
          <td class="headTh" style="width: 10%">
            <div class="verbar">
              <a style="line-height: 20px">
                <p>Price</p>
                <p>breakdown</p>
                <p @click="openfee(index)">
                  <svg-icon size="13" name="a-xiala" v-if="item.showFee"></svg-icon>
                  <svg-icon size="13" name="xiala" v-else></svg-icon>
                </p>
              </a>
            </div>
          </td>
          <td class="headTh last" style="width: 12%">
            <div class="right-label" v-if="item.SpaceType">
              <div :class="{
                  Sufficient: item.SpaceType == 1,
                  TightLabel: item.SpaceType == 2,
                  Casebycase: item.SpaceType == 3,
                  Overbooked: item.SpaceType == 4,
                }">
                {{
                  item.SpaceType == 1
                    ? "Sufficient"
                    : item.SpaceType == 2
                    ? "Tight"
                    : item.SpaceType == 3
                    ? "Case by case"
                    : "Overbooked"
                }}
              </div>
            </div>
            <p>
              <b class="font14" style="color: #cf3737">US ${{ Number(item.TotalFee).toFixed(2) }}</b>
            </p>
            <p>
              <a class="blueBtnW marTop5" @click="enterSelect(index, item)">SELECT</a>
            </p>
          </td>
        </tr>

        <tr class="feeList font12" v-show="feeList.includes(index)" style="background: #f2f2f2" v-if="item.showleft">
          <td colspan="10">
            <!-- 费用详情 -->
            <div class="td-info">
              <div class="title">
                <div>Cost items</div>
                <div>Unit rate</div>
                <div>QTY</div>
                <div>Amount</div>
              </div>
              <div class="info" style="border-top: none">
                <div>Air Freight Cost</div>
                <div>US ${{ item.AirPrice.toFixed(2) }}/KG</div>
                <div>{{ item.AirChargeWeight.toFixed(2) }}KG</div>
                <div>US ${{ item.AirTracficFee.toFixed(2) }}</div>
              </div>
              <div class="info lcalCharge" v-if="item.LstAirFee.length > 0">
                <div>Local charge</div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="info" v-for="(item, index) in item.LstAirFee" :key="index">
                <div>{{ item.FeeNameEn }}</div>
                <div>
                  US ${{ (item.Amount / item.Quanlity + 0.004).toFixed(2) }}/{{
                    getUnit(item.Unit, true)
                  }}
                </div>
                <div v-if="item.Unit == 1 || item.Unit == 3">
                  {{ item.Quanlity.toFixed(2) }} {{ getUnit(item.Unit) }}
                </div>
                <div v-if="item.Unit != 1 && item.Unit != 3">
                  {{ item.Quanlity }} <span v-html="getUnit(item.Unit)"></span>
                </div>
                <div>US${{ item.Amount.toFixed(2) }}</div>
              </div>
              <div class="info" v-if="item.THAmount">
                <div>Pickup Charge（{{ item.ThWorkDay }}days）</div>
                <div>US ${{ item.THAmount.toFixed(2) }}/Bill</div>
                <div>1 Shipment</div>
                <div>US${{ item.THAmount.toFixed(2) }}</div>
              </div>
              <div class="info" v-if="
                  Number(
                    Number(item.THAmount ? item.THAmount : 0) +
                      Number(item.AirTracficFee ? item.AirTracficFee : 0)
                  ).toFixed(2) == item.THAmount.toFixed(2)
                ">
                <div class="amount">
                  Subtotal : US${{
                    Number(
                      Number(item.THAmount ? item.THAmount : 0) +
                        Number(item.AirTracficFee ? item.AirTracficFee : 0)
                    ).toFixed(2)
                  }}
                </div>
              </div>
              <div class="total">
                <div>
                  <div class="circle">
                    <div class="tishi">
                      <!-- <svg-icon size="13" name="a-Group40"></svg-icon> -->
                      <img src="../../../../../static/img/Group 2@2x.png" alt="" />
                      <div class="floTipBox">
                        <i></i>
                        <p>
                          If your actual shipment is different from the information
                          provided, you may incur additional fees.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="text">Total：US ${{ item.TotalFee.toFixed(2) }}</div>
                </div>
              </div>

              <div class="remark" v-if="item.Clause">
                <div>Remark:</div>
                <div v-html="item.Clause.replace(/(\r\n)|(\n)/g, '<br>')"></div>
                <!-- <div>1.Including FSC & SCC and our profit share.</div>
              <div>2.The above rates are based on chargeable weight on HAWB.</div>
              <div>3.For volumetric cargo, if gross weight increase or volume weight decrease, the rates will change accordingly.</div> -->
              </div>
            </div>
          </td>
        </tr>
      </table>
    </template>

    <!-- <table
      border="0"
      cellspacing="0"
      cellpadding="0"
      class="fff channelList"
      width="100%"
      v-for="(item, index) in feeData"
      :key="index"
    >
      <tr style="border-bottom: 1px solid #dfdfdf">
        <td
          width="10%"
          align="center"
          class="pad10"
          style="border-right: 1px solid #dfdfdf"
        >
          <p>
            <span
              class="fa fa-AirWarehouse colBlue"
              style="font-size: 30px"
            ></span>
          </p>
          <p class="marTop5" style="display: none;">
            <b>{{ item.AirWareShortCode }}</b>
          </p>
        </td>
        <td width="75%" align="left" class="pad10 clear">
          <p>
            <b class="colBrack">{{
              item.AirCompanyNameEn +
              " " +
              item.AirCompanyCode2 +
              "-" +
              item.AirCompanyCode3
            }}</b
            ><b class="r colBrack">{{
              item.AirArrivalType == 1 ? "Direct" : "Transit"
            }}</b>
          </p>
          <div class="clear">
            <p class="l colGray6" style="line-height: 30px; min-width: 160px">
              Transit time: {{ item.ValidTerm }}Days
            </p>
            <p class="l colGray6" style="line-height: 30px">
              Route: {{ item.FlightCourse }}
            </p>
            <p class="l colGray6" style="line-height: 30px; margin-left: 20px">
              Frequency: {{ item.Flight }}
            </p>
          </div>
          <p class="cl colGray6" style="line-height: 20px">
            <span class="l"
              >Valid until:
              {{
                new Date(item.AirValidEndTime) | dateFmt("MMM DD, YYYY")
              }}</span
            >
            <a class="colBlue r marL20" @click="openfee(index)"
              >Price breakdown<i
                class="fa fa-arrDown colBlue"
                style="margin-top: -3px"
              ></i
            ></a>
          </p>
        </td>
        <td
          align="center"
          style="border-left: 1px solid #dfdfdf; padding: 13px 10px"
        >
          <p>
            <b class="colRed font14"
              >US
              {{
                Number(item.TotalFee / item.AirChargeWeight).toFixed(2)
              }}/KG</b
            >
          </p>
          <p>
            <b class="colRed font14"
              >US ${{ Number(item.TotalFee).toFixed(2) }}</b
            >
          </p>
          <p>
            <a class="blueBtnW marTop5" @click="enterBox(index,item)">SELECT</a>
          </p>
        </td>
      </tr>
      <tr class="feeList font12" v-show="feeList.includes(index)">
        <td colspan="3">
          <div class="title">
            <h3>{{ item.StartAirPortCode3 }} > {{ item.DestAirPortCode3 }}</h3>
          </div>
          <table
            border="0"
            cellspacing="0"
            cellpadding="0"
            class="channel"
            width="100%"
          >
            <tr>
              <th width="40%" align="left">Cost items</th>
              <th width="18%" align="left">Unit rate</th>
              <th width="17%" align="left">QTY</th>
              <th align="right">Amount</th>
            </tr>
            <tr v-show="item.THAmount" style="font-size: 13px">
              <td width="40%" align="left">
                <p>Pickup Charge({{ item.ThWorkDay }} days)</p>
              </td>
              <td width="17%" align="left">
                US ${{ item.THAmount.toFixed(2) }}/Bill
              </td>
              <td width="18%" align="left">1 Shipment</td>
              <td align="right">
                <p class="colRed">
                  <b> US ${{ item.THAmount.toFixed(2) }}</b>
                </p>
              </td>
            </tr>
            <tr class="font13">
              <td width="40%" align="left">
                <p>Air Freight Cost</p>
              </td>
              <td width="17%" align="left">
                US ${{ item.AirPrice.toFixed(2) }}/KG
              </td>
              <td width="18%" align="left">
                {{ item.AirChargeWeight.toFixed(2) }}KG
              </td>
              <td align="right">
                <p class="colRed">
                  <b> US ${{ item.AirTracficFee.toFixed(2) }}</b>
                </p>
              </td>
            </tr>
            <tr
              class="font13"
              v-for="(item, index) in item.LstAirFee"
              :key="index"
            >
              <td width="40%" align="left">
                <p>{{ item.FeeNameEn }}</p>
              </td>
              <td width="17%" align="left">
                US ${{ (item.Amount / item.Quanlity).toFixed(2) }}/{{
                  getUnit(item.Unit, true)
                }}
              </td>
              <td
                v-if="item.Unit == 1 || item.Unit == 3"
                width="18%"
                align="left"
              >
                {{ item.Quanlity.toFixed(2) }}{{ getUnit(item.Unit) }}
              </td>
              <td
                v-if="item.Unit != 1 && item.Unit != 3"
                width="18%"
                align="left"
              >
                {{ item.Quanlity }}<span v-html="getUnit(item.Unit)"></span>
              </td>
              <td align="right">
                <p class="colRed">
                  <b>US ${{ item.Amount.toFixed(2) }}</b>
                </p>
                <p
                  class="spcText"
                  v-if="item.MaxValue != null && item.MinValue != null"
                >
                  (
                  <span v-if="item.MaxValue != null"
                    >Max US ${{ Number(item.MaxValue).toFixed(2) }}</span
                  >
                  <span v-if="item.MinValue != null"
                    >,Min US ${{ Number(item.MinValue).toFixed(2) }}</span
                  >)
                </p>
              </td>
            </tr>
            <tr class="feeList channelTr LastBotTr font14">
              <td colspan="4" align="right" class="padLR10 bold">
                <span>Subtotal：</span>
                <div style="display: inline-block" class="colRed">
                  US ${{ topTotal(item) }}
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr
        class="feeList channelTr dashedLine font13"
        v-show="feeList.includes(index)"
        v-if="!isWCA"
      >
        <td colspan="2" align="left" class="padLR10">Bank Charge</td>
        <td align="right" class="padLR10 colRed bold">
          US ${{ item.BankChargeAmount.toFixed(2) }}
        </td>
      </tr>
      <tr
        class="feeList channelTr LastBotTr font14"
        v-show="feeList.includes(index)"
      >
        <td colspan="4" align="right" class="padLR10 bold">
          <span>Subtotal：</span>
          <div style="display: inline-block" class="colRed">
            US ${{ botTotal(item) }}
          </div>
        </td>
      </tr>
      <tr
        class="feeList channelTr LastBotTr"
        style="font-size: 16px"
        v-show="feeList.includes(index)"
      >
        <td colspan="3" align="right" class="padLR10 bold">
          <label class="hint">
            <i class="fa fa-tips colRed marR5" style="margin-top: -4px"></i>
            <div class="floTipBox" style="width: 400px; left: -50px; top: 30px">
              <i style="right: 55px"></i>
              <p style="color: #4a4a4a">
                If your actual shipment is different from the information
                provided, you may incur additional fees.
              </p>
            </div>
          </label>
          <span>Total：</span>
          <div style="display: inline-block; width: 242px" class="colRed">
            US ${{ item.TotalFee.toFixed(2) }}
          </div>
        </td>
      </tr>
    </table> -->
  </div>
</template>
<script>
import { getCookie } from "../../../../ask/cookiejs";
import { post, fetch, Del, put } from "@/ask/axios";
import { elAlert } from "@/utils/bulletBox";
import EventBus from "@/ask/eventBus";
export default {
  props: {
    feeData: Array,
    newList: {
      type: Array,
    },
    parmaData: Object,
    cargoData: Array,
    curDensity: String,
    getProportion: String,
    isCheckSortBy: Boolean,
    tiaoshu: Number,
  },
  data() {
    return {
      feeList: [], //报价详情展开[]代表没有展开
      isWCA: false,
      //是否登录
      isLogin: false,
      showFee: false,
      getKg: "",
    };
  },
  created() {
    //  this.reqList();
    if (!this.isCheckSortBy) {
      this.reqList();
    } else {
      let list = [];
      this.newList.forEach((item) => {
        this.getKg = this.checkKG(item.AirChargeWeight);
        if (item.showleft) {
          list.push(item);
        }
      });
      //"返回list集合====",list);
      //注意：不能在子组件修改从父组件传过来的newList，既然不能在这里修改，反正都要将index传出去，那就通过emit传出去吧
      //告知Home组件根据下标来给Goods传数据
      this.$emit("choseItem", list);
    }

    //点击左侧栏筛选
    EventBus.$on("checkEnquiry", (msg) => {
      this.$forceUpdate();
      if (msg.startCode3 && msg.airlineCode2 != "" && msg.arrivalType) {
        this.feeData.forEach((item) => {
          if (
            msg.startCode3.includes(item.StartAirPortCode3) &&
            msg.airlineCode2.includes(item.AirCompanyCode2)
          ) {
            item.showleft = true;
            if (msg.arrivalType == 1) {
              //直达

              item.showleft = item.AirArrivalType == 1 ? true : false;
            } else {
              item.showleft = true;
            }
          } else {
            item.showleft = false;
          }
        });
      }
      if (msg.startCode3 && msg.airlineCode2 != "" && msg.arrivalType == "") {
        this.feeData.forEach((item) => {
          if (
            msg.startCode3.includes(item.StartAirPortCode3) &&
            msg.airlineCode2.includes(item.AirCompanyCode2)
          ) {
            item.showleft = true;
          } else {
            item.showleft = false;
          }
        });
      }
      if (msg.startCode3 && msg.airlineCode2 == "") {
        this.feeData.forEach((item) => {
          if (msg.startCode3.includes(item.StartAirPortCode3)) {
            if (msg.arrivalType == 1) {
              //直达

              item.showleft = item.AirArrivalType == 1 ? true : false;
            } else {
              item.showleft = true;
            }
          } else {
            item.showleft = false;
          }
        });
      }
      if (msg.startCode3 == "" && msg.airlineCode2) {
        this.feeData.forEach((item) => {
          if (msg.airlineCode2.includes(item.AirCompanyCode2)) {
            if (msg.arrivalType == 1) {
              //直达

              item.showleft = item.AirArrivalType == 1 ? true : false;
            } else {
              item.showleft = true;
            }
          } else {
            item.showleft = false;
          }
        });
      }
    });
  },
  computed: {
    topTotal() {
      return function (item) {
        let sTotalFee = 0;
        for (let i = 0; i < item.LstAirFee.length; i++) {
          sTotalFee += Number(item.LstAirFee[i].Amount);
        }
        let sum =
          Number(sTotalFee) +
          +(item.THAmount ? Number(item.THAmount) : 0) +
          (item.AirTracficFee ? Number(item.AirTracficFee) : 0);
        return sum.toFixed(2);
      };
    },
    // botTotal() {
    //   return function (item) {
    //     let eTotalFee = 0;
    //     for (let i = 0; i < item.LstDestFee.length; i++) {
    //       eTotalFee += Number(item.LstDestFee[i].Amount);
    //     }
    //     let sum =
    //       Number(eTotalFee) +
    //       (this.isWCA
    //         ? 0
    //         : item.BankChargeAmount
    //         ? Number(item.BankChargeAmount)
    //         : 0) +
    //       (item.DeliverAmount ? Number(item.DeliverAmount) : 0) +
    //       (item.BondAmount ? Number(item.BondAmount) : 0);
    //     return sum.toFixed(2);
    //   };
    // },
  },
  methods: {
    reqList() {
      this.feeData.forEach((item) => {
        this.getKg = this.checkKG(item.AirChargeWeight);
        item.showFee = false;
        item.showleft = true;
      });
    },

    checkKG(Kg) {
      if (Kg > 0 && Kg < 100) {
        return "45";
      } else if (Kg >= 100 && Kg < 300) {
        return "100";
      } else if (Kg >= 300 && Kg < 500) {
        return "300";
      } else if (Kg >= 500 && Kg < 1000) {
        return "500";
      } else {
        return "1000";
      }
    },
    // 展开
    openfee(Flagindex) {
      this.feeData[Flagindex].showFee = !this.feeData[Flagindex].showFee;
      if (!this.feeList.length) {
        this.feeList.push(Flagindex);
        return;
      }

      for (let i = 0; i < this.feeList.length; i++) {
        if (this.feeList[i] == Flagindex) {
          this.feeList.splice(i, 1);
          return;
        }
      }
      this.feeList.push(Flagindex);
    },
    getUnit(unit, hasBill) {
      // 计费单位 目的地费用:（0：票，1：CBM，2：份，3：KG,4：页，5：单,6：天，7：次，8：件）
      switch (unit) {
        case 0:
          if (hasBill) {
            return "Bill";
          }
          return "B\\L";
        case 1:
          return "CBM";
        case 2:
          return "Pcs";
        case 3:
          return "KG";
        case 4:
          return "Page";
        case 5:
          if (hasBill) {
            return "Bill";
          }
          return "B\\L";
        case 6:
          return "Day";
        case 7:
          return "Time";
        case 8:
          return "Unit";
      }
    },
    enterSelect(index, item) {
      //创建后
      let token = getCookie("X-BY-EnTOKEN");
      if (token && token != "null") {
        this.isLogin = true;
        this.$router.push("/checkList/quotes");
      } else {
        this.isLogin = false;
        elAlert(this, "You have not logged in, please log in");
      }
    },
    enterBox(index, item) {
      let { cargoEn, cargoCn } = this.getCurCargo();
      let radCargo = this.parmaData.GoodInfos.map((item) => {
        return {
          Long: item.Long,
          Wide: item.Wide,
          High: item.Height,
          Quanlity: item.Quanlity,
          Unit: item.unit,
          Weight: item.Weight,
          VolumeUnit: this.parmaData.QueryGoodType,
          LongIN: item.Long / 2.54,
          WideIN: item.Wide / 2.54,
          HighIN: item.Height / 2.54,
          VolumeCFT:
            ((Number(item.Long) * Number(item.Wide) * Number(item.Height)) / 1000000) *
            Number(item.Quanlity) *
            35.3147248,
          WeightLB: Number(item.Quanlity) * (Number(item.Weight) * 2.2046226),
        };
      });

      let curChannel = this.feeData[index];
      let param = {
        Order: {
          AirChannelKey: curChannel.AirChannelKey,
          AirCompanyKey: curChannel.AirCompanyKey,
          AirCompanyCode: curChannel.AirCompanyCode2,
          AirCompanyName: curChannel.AirCompanyName,
          DepartureCode: curChannel.StartAirPortCode3,
          DepartureName: curChannel.StartAirportName,
          DestinationCode: curChannel.DestAirPortCode3,
          DestinationName: curChannel.DestAirportName,
          FlightInfo: curChannel.Flight,
          ValidTerm: curChannel.ValidTerm,
          AirArrivalType: curChannel.AirArrivalType,
          OrderPrice: curChannel.AirPrice,
          OrderAmount: curChannel.TotalFee,
          OrderTrafficAmount: curChannel.AirTracficFee,
          OrderWeight: curChannel.AirChargeWeight,
          SecondFlight: curChannel.SecondFlight,
          TransferAirport: curChannel.TransferAirportCode3,
          AirChannelName: curChannel.AirChannelName,
          DepartureNameEn: curChannel.StartAirportNameEn,
          DestinationNameEn: curChannel.DestAirportNameEn,
          AirCompanyCode3: curChannel.AirCompanyCode3,
          PackageQuanlity: this.parmaData.TotalQuanlity,
          Weight: this.parmaData.TotalWeight,
          VolumeCBM: this.parmaData.TotalCBM,
          OrderServiceType: 3,
          QueryGoodType: this.parmaData.QueryGoodType,
          WeightLB: this.parmaData.TotalWeight * 2.2046226,
          VolumeCFT: this.parmaData.TotalCBM * 35.3147248,
          PackageUnit: this.parmaData.UnitLabel,
          CargoIDs: this.parmaData.CargoTypeIDs.join(),
          QueryGoodUnit: this.parmaData.QueryGoodUnit,
          CargoNameCn: cargoCn,
          CargoNameEn: cargoEn,
        },
        OrderExt: {
          THChannelKey: curChannel.THChannelKey,
          DestSvcID: curChannel.DestSvcID,
        },
        GoodVolumeList: radCargo,
        DeliverOrder: {
          DestSvcID: curChannel.DestSvcID,
        },
        FeeItem: curChannel.LstAirFee.concat(curChannel.LstDestFee),
      };
      let url = this.$api03 + "/api/TradeCustomer/AirOrderEn/AddConfirmOrder";
      post(url, param).then((res) => {
        if (res.IsOK == true) {
          let startText = item.StartAirPortCode3 + "[" + item.StartAirportNameEn + "]";
          let endText = item.DestAirPortCode3 + "[" + item.DestAirportNameEn + "]";

          // this.submitOrder(res.Results.WaybillNO,item.TotalFee,'','FREIGHT',startText,'',endText,item.DestAirportCountryCode,cargoEn,
          // this.parmaData.TotalWeight,this.parmaData.TotalCBM,this.parmaData.TotalQuanlity,item.AirChargeWeight,'',item.AirChannelName,item.TotalFee,'','',false)

          window.location.href = "/air/airEdit?ord=" + res.Results.WaybillNO;
        } else {
          // if(!getCookie('X-BY-EnTOKEN')) {
          if (res.ErrorCode == "401") {
            elAlert(this, "Login timeout, please try again");
          }
          // }
        }
      });
    },
    getCurCargo() {
      var cargoEn = [];
      var cargoCn = [];
      this.parmaData.cargoTypeIDList.forEach((item) => {
        this.cargoData.forEach((ele) => {
          if (item == ele.Id) {
            cargoEn.push(ele.AttrVal_ContentEn);
            cargoCn.push(ele.AttrVal_ContentEn);
          }
        });
      });
      return {
        cargoCn: cargoCn.join(","),
        cargoEn: cargoEn.join(","),
      };
    },
  },
};
</script>
<style scoped lang="less">
.channel {
  font-size: 14px;
}
.channelList {
  margin-bottom: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.channelList1 {
  margin-bottom: 10px;
}
.channel tr {
  height: 40px;
}
.channel tr td {
  padding: 8px 0;
}
.channel tr td:last-child {
  padding-right: 10px;
}
.channel tr th:last-child {
  padding-right: 10px;
}
.channel tr td:first-child {
  padding-left: 10px;
}
.channel tr th:first-child {
  padding-left: 10px;
}
.channelTr td:first-child {
  padding-left: 10px;
}
.channelTr td:last-child {
  padding-right: 10px;
}
.channelTr {
  height: 40px;
}
.feeList .title h3 {
  color: #004fb1;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  background: #f8fafc;
}
.blueBtnW {
  border: 1px solid #004fb1;
  border-radius: 30px;
  width: 100px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: #004fb1;
  color: #fff !important;
  display: inline-block;
}
.headTr {
  height: 50px;
  background-color: #fff !important;
}
.headTh {
  text-align: center;
}
.headThColor {
  text-align: center;
  color: #004fb1;
}

.one {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}
.last {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.polpod {
  width: 115px;
  display: inline-block;
  font-size: 12px;
  position: absolute;
  margin: 10px -48px;
  line-height: 20px;
}
.dateClass {
  margin: auto;
  color: #004fb1;
  font-size: 9px;
  width: 140px;
  height: 45px;
  border-style: hidden;
  opacity: 0.6;
  border-radius: 10px;
  line-height: 28px;
}
.dateClass td {
  border: 1px dotted #004fb1;
  width: 100;
  height: 25;
}
.selectDate {
  background: #004fb1;
  color: #ffffff;
}
.polClass {
  position: absolute;
  margin: -4px 19px;
}
.podClass {
  margin: -4px 20px;
  float: right;
}
.daysClass {
  margin-left: -29px;
  margin-bottom: -7px;
}
.transClass {
  margin-left: -28px;
  margin-top: -3px;
}
.transClass:hover + .demo {
  display: block;
}
.demo {
  display: none;
  width: 150px;
  height: 48px;
  line-height: 48px;
  box-shadow: 0px 5px 12px 0px rgb(0 0 0 / 13%);
  border: 2px solid rgba(196, 196, 196, 0.56);
  position: relative;
  background: #ffffff;
  margin: 10px -33px;
}
.out,
.in {
  position: absolute;
  width: 0;
  height: 0px;
}
.out {
  border: 11px solid transparent;
  border-bottom-color: rgba(
    196,
    196,
    196,
    0.56
  ); /*这里的颜色一定要跟上面demo边框颜色一样*/
  top: -22px;
  left: 42%;
}
.in {
  border: 11px solid transparent;
  border-bottom-color: #fff; /*这里的颜色一定要跟demo背景颜色一样*/
  top: -19px;
  left: 42%;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #aaaaaa;
  position: absolute;
  margin-left: 5px;
  margin-top: 10px;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #aaaaaa;
  margin-top: 4px;
}

.td-info {
  height: auto;
  margin: 1px 20px 0 20px;
  position: relative;
  z-index: 0;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 10px 10px;
  width: 96%;

  .title {
    padding: 11px 0 9px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #f9fafc;
    height: 40px;
    box-sizing: border-box;
    border-bottom: solid 1px #e2e2e2;
    div {
      flex: 1;
      padding: 0 30px;

      font-size: 14px;
      font-family: "MicrosoftYaHei";
      color: #333333;
      line-height: 20px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    div:first-child {
      text-align: left;
    }

    div:nth-child(2),
    div:nth-child(3) {
      text-align: center;
    }

    div:last-child {
      text-align: right;
    }
  }

  .info {
    padding: 5px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px dashed #e2e2e2;
    height: 32px;
    box-sizing: border-box;
    div {
      flex: 1;
      padding: 0 30px;

      font-size: 13px;
      font-family: "MicrosoftYaHei";
      color: #636363;
      line-height: 24px;
      font-weight: 400;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    div:first-child {
      text-align: left;
    }

    div:nth-child(2),
    div:nth-child(3) {
      text-align: center;
    }

    div:last-child {
      text-align: right;
    }

    .amount {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-align: right;
      line-height: 18px;
    }
  }

  .total {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: 10px 30px;
    background: #f8fafc;
    border-radius: 0 0 10px 10px;
    .circle {
      display: inline-block;
      margin-right: 10px;
      img {
        width: 16px;
        height: 16px;
        position: relative;
        top: 2px;
        left: 8px;
      }
    }

    .text {
      display: inline-block;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #cf3737;
      line-height: 24px;
    }
  }

  .remark {
    padding: 6px 0 20px 30px;

    div {
      margin-top: 5px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #636363;
      line-height: 16px;
    }

    div:first-child {
      margin-top: 0;
    }
  }
}

.vertical {
  border-right: 1px solid #dfdfdf;
  height: 30px;
  line-height: 30px;
}
.verbar {
  border-right: 1px solid #dfdfdf;
  height: 60px;
  line-height: 60px;
}
.codeTwo {
  position: absolute;
  margin-top: 20px;
  margin-left: -40px;
}
.colorClass {
  line-height: 14px;
}
.left-label {
  width: 32px;
  height: 32px;
  position: relative;
  top: -6px;
}
.marTop {
  position: relative;
  top: -12px;
}
.right-label {
  width: max-content;
  height: 24px;
  margin: -15px 0px 0 54px;
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  float: right;
}
.Sufficient {
  border-radius: 12px 10px 0px 12px;
  background: #e2f2db;
  color: #4dae1f;
  width: 75px;
}
.TightLabel {
  background: #ffebda;
  border-radius: 12px 10px 0px 12px;
  color: #ff841a;
  width: 56px;
}
.Overbooked {
  background: #f9e0e0;
  border-radius: 12px 10px 0px 12px;
  color: #d83f3f;
  width: 91px;
}
.Casebycase {
  background: rgba(0, 108, 243, 0.16);
  border-radius: 12px 10px 0px 12px;
  color: #006cf3;
  width: 99px;
}
.lcalCharge {
  height: 32px !important;

  border-bottom: solid 1px rgba(226, 226, 226, 0.8) !important;
  background: #f9fafc;
  div {
    font-size: 13px !important;
    font-family: PingFangSC-Medium, PingFang SC !important;
    font-weight: 500 !important;
    color: #333333 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/result/resTable.vue